export const sendQuery = async <T>(url: string, method: "POST" | "GET" | "PUT", token: string, data?: any) => {
  const result = await fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: data ? JSON.stringify(data) : undefined,
  });

  if (result.ok) {
    return {
      success: true,
      error: false,
      errorMessage: null,
      data: (await result.json()) as T,
    };
  }

  return {
    success: false,
    error: true,
    errorMessage: result.statusText,
    data: null as T,
  };
};

export async function swrFetcher<JSON = any>(input: RequestInfo, init?: RequestInit): Promise<JSON> {
  const res = await fetch(input, init);

  if (res.status === 401) {
    // Clear any stored auth state
    sessionStorage.clear();
    localStorage.clear();

    // Redirect to root which will show login screen
    window.location.href = `${window.location.origin}/taskpane.html`;
    throw new Error("Unauthorized");
  }

  if (!res.ok) {
    throw new Error(res.statusText);
  }

  return res.json().catch((e) => {
    console.error(e);
  });
}
